<template>
    <div class="error-notification p-4">
        <div class="d-flex justify-content-center">
            <img class="icon mt-1 pr-3" src="@/assets/attention.svg" />
            <p class="error-text" v-html="errorNotification"></p>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        errorNotification: {
            type: String,
            required: true
        }
    })

    // If you want to log the prop as in the original mounted hook:
    import { onMounted } from 'vue'
    onMounted(() => {
        console.log(props.errorNotification)
    })
</script>

<style lang="scss" scoped>
    .icon {
        height: 12px !important;
    }
</style>
